import {z} from 'zod';

export const outputQualitySchema = z.enum(['auto', 'low', 'medium', 'high']);
export type OutputQuality = z.infer<typeof outputQualitySchema>;

export const outputShapeSchema = z.enum(['auto', 'square', 'portrait', 'landscape']);
export type OutputShape = z.infer<typeof outputShapeSchema>;

/** Stored document shape in Firestore (user/{uid}/generationJobProject/{id}) */
export const generationJobProjectFirebaseSchema = z.object({
  name: z.string().optional(),
  gdriveTokenId: z.string(),
  sourceImageFileId: z.string().optional(),
  sourceImageUrl: z.string().optional(),
  sheetId: z.string(),
  outputFolderId: z.string(),
  creationTimestamp: z.number(),
  systemPrompt: z.string().optional(),
  edit: z.boolean().optional(),
  outputQuality: outputQualitySchema.optional(),
  outputShape: outputShapeSchema.optional(),
});

export type GenerationJobProjectFirebase = z.infer<typeof generationJobProjectFirebaseSchema>;

/** Document with id (for reading from Firestore) */
export interface GenerationJobProject extends GenerationJobProjectFirebase {
  id: string;
}

/** Input shape for create/update (sheet and output as URL or id) */
export const generationJobProjectInputSchema = z.object({
  name: z.string().optional(),
  gdriveTokenId: z.string(),
  sourceImageFileId: z.string().optional(),
  sourceImageUrl: z.string().optional(),
  sheetUrlOrId: z.string(),
  outputFolderUrlOrId: z.string(),
  systemPrompt: z.string().optional(),
  edit: z.boolean().optional(),
  outputQuality: outputQualitySchema.optional(),
  outputShape: outputShapeSchema.optional(),
});

export type GenerationJobProjectInput = z.infer<typeof generationJobProjectInputSchema>;
